import { render } from "./TournamentLiveScoringHH.vue?vue&type=template&id=a6e5661a&scoped=true"
import script from "./TournamentLiveScoringHH.vue?vue&type=script&lang=js"
export * from "./TournamentLiveScoringHH.vue?vue&type=script&lang=js"

import "./TournamentLiveScoringHH.vue?vue&type=style&index=0&id=a6e5661a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6e5661a"]])

export default __exports__